import { PublicClientApplication } from '@azure/msal-browser'
import config from 'src/config/config'
import { appInsights } from 'src/AppInsights'
import { msalInstance } from 'src/auth/msal'
// var token = `${localStorage.getItem("accesstoken")}`;

const publicClientApplication = new PublicClientApplication({
  auth: {
    clientId: config.AUTH_APP_ID,
    redirectUri: config.AUTH_REDIRECT_URI,
    authority: config.AUTHORITY,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
    secureCookies: false,
  },
})

// AZURE AD login
export const azureADLogin = async () => {
  try {
    await publicClientApplication.loginPopup({
      scopes: config.SCOPES,
      prompt: 'select_account',
    })
    return {
      status: 200,
      data: localStorage,
    }
  } catch (error) {
    return error.message
  }
}

export default function emptyCache() {
  if ('caches' in window) {
    caches.keys().then((names) => {
      // Delete all the cache files
      names.forEach((name) => {
        caches.delete(name)
      })
    })

    // Makes sure the page reloads. Changes are only visible after you refresh.
    // window.location.reload(true)
  }
}

//Logout
export const doLogout = async () => {
  try {
    emptyCache()
    const account = msalInstance.getActiveAccount()
    msalInstance.logoutRedirect({ account: account })
    appInsights.unload()
    return {
      status: 200,
      data: 'Logged Out',
    }
  } catch (error) {
    return error.message
  }
}

export const fetchUser = async (token) => {
  try {
    const response = await fetch(`${config.API_URL}/v1/common/get-user`, {
      headers: { Authorization: 'Bearer ' + token },
      'Content-Type': 'application/json',
    })
    if (!response.ok) {
      throw new Error('Something went wrong!')
    }
    const dBdata = await response.json()
    return {
      status: response.status,
      data: dBdata,
    }
  } catch (error) {
    // navigateHome()
    return error.message
  }
}

export const fetchUserDefaultRoute = async (token) => {
  try {
    const response = await fetch(`${config.API_URL}/v1/common/get-user-with-default-route`, {
      headers: { Authorization: 'Bearer ' + token },
    })
    if (!response.ok) {
      throw new Error('Something went wrong!')
    }
    const dBdata = await response.json()
    return {
      status: response.status,
      data: dBdata,
    }
  } catch (error) {
    // navigateHome()
    return error.message
  }
}

export const fetchAppConfig = async (token) => {
  try {
    const response = await fetch(`${config.API_URL}/v1/app-config/get-config`, {
      headers: { Authorization: 'Bearer ' + token },
    })
    if (!response.ok) {
      if (response.status === 403) {
        console.log(response)
        throw Error(response.statusText)
      }
      throw new Error('Something went wrong!')
    }
    const dBdata = await response.json()
    return {
      status: response.status,
      data: dBdata,
    }
  } catch (error) {
    if (error.message === 'Forbidden') {
      // alert('Session Expired!. Please Login Again.')
      doLogout()
      navigateHome()
      console.log(error)
    }
    return error.message
  }
}

export const navigateHome = () => {
  clearAllStorages()
  window.location.reload(true) // perform a hard refresh
  window.location.assign('/')
}

export const clearAllStorages = () => {
  localStorage.clear()
  sessionStorage.clear()
  document.cookie = ''
}

export async function getUserDetailsFromAccessToken(token) {
  let response = await fetchUser(token)
  if (response.status === 200) {
    return response.data
  }
}

async function getConfigDetails() {
  try {
    const response = await fetch(`${config.API_URL}/v1/configurations/app-settings`, {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('accesstoken') },
    })
    const data = await response.json()
    return data
  } catch (err) {
    console.log('err: ', err)
  }
}

export async function setTokensInLocalStorage() {
  try {
    let sessionStorageValues = Object.values(sessionStorage)
    let values = sessionStorageValues.filter((store) => {
      try {
        if (JSON.parse(store).hasOwnProperty('credentialType')) return JSON.parse(store)
      } catch (error) {}
    })
    values.map((e) => {
      let credentialType = JSON.parse(e).credentialType
      if (credentialType === 'IdToken') localStorage.setItem('accesstoken', JSON.parse(e).secret)
      else if (credentialType === 'RefreshToken')
        localStorage.setItem('refreshtoken', JSON.parse(e).secret)
    })
    let user = await getUserDetailsFromAccessToken(localStorage.getItem('accesstoken'))
    localStorage.setItem('uname', JSON.stringify(user))
    if (user?.currency_preference && user?.theme_preference) {
      localStorage.setItem('default_currency', user?.currency_preference)
      localStorage.setItem('theme', user?.theme_preference)
    } else {
      const response = await getConfigDetails()
      if (user?.theme_preference) {
        localStorage.setItem('theme', user?.theme_preference)
      } else {
        const theme = response?.data.find((el) => el.name === 'default_theme')
        theme?.value && localStorage.setItem('theme', theme?.value)
      }
      if (user?.currency_preference) {
        localStorage.setItem('default_currency', user?.currency_preference)
      } else {
        const currency = response?.data?.find((el) => el.name === 'default_currency')
        currency?.value && localStorage.setItem('default_currency', currency?.value)
      }
    }
  } catch (error) {
    throw new Error(error)
  }
}
